import React from "react";
import { isMobile } from "../../../../helpers/Mobile";
import i18n from "i18n";
import styles from "./atoms.SummaryButton.module.scss";
import SVGIconComponent from '../../atoms/Icon/icon';
import repeatIcon from '../../../../assets/images/repeate-music.png'

export const SummaryButton = ({ icon, title, pending, processing, clickHandler }) => {
    return (
        <div className={styles["summary-button-container"]} onClick={clickHandler}>
            <div className={styles["summary-button-left"]}>
                <SVGIconComponent
                    className={icon}
                    name={icon}
                    width={'34'}
                    height={'34'}
                    fill={"#494F66"}
                ></SVGIconComponent>
                <div className={styles["summary-button-title"]}>
                    {title}
                </div>
            </div>
            <div className={styles["summary-button-divider"]}></div>
            <div className={styles["summary-button-right"]}>
                <div className={styles["summary-button-right-wrapper"]}>
                    {pending > 0 && <div className={styles["summary-button-pending"]}>
                        <SVGIconComponent
                            className={'alert'}
                            name={'alert'}
                            width={isMobile ? '9' : '14'}
                            height={isMobile ? '9' : '14'}
                            fill={"#FFAF3A"}
                        ></SVGIconComponent>
                        <div className={styles["summary-button-pending-text"]}> {i18n.t("total.pending")}</div>
                        <div className={styles["summary-button-pending-number"]}> {pending}</div>
                    </div>}
                    {processing > 0 && <div className={styles["summary-button-processing"]}>
                        <img className={styles["icon-repeat-processing"]} src={repeatIcon} alt="icon"></img>
                        <div className={styles["summary-button-processing-text"]}> {i18n.t("total.in.process")}</div>
                        <div className={styles["summary-button-processing-number"]}> {processing}</div>
                    </div>}
                </div>
            </div>
            <div className={styles["summary-button-chevron"]}>
                <i className={styles["icon-chevron-derecha"]}></i>
            </div>
        </div>
    )
}

export default SummaryButton;